import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

const SavedQueriesList = ({
  queries,
  selectedQuery,
  onSelect,
  onDelete,
  searchTerm,
  onSearchChange,
  onAddNew,
  loading,
}) => {
  const filteredQueries = queries.filter(
    (q) =>
      (q.title || q.Title || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (q.description || q.Description || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (q.tenantName || q.TenantName || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="p-4 border-b border-gray-100 dark:border-slate-800 bg-gray-50 dark:bg-slate-950">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-bold text-gray-800 dark:text-gray-200">Saved Queries</h3>
          <button
            onClick={onAddNew}
            className="p-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            aria-label="Add query"
          >
            <Plus size={16} />
          </button>
        </div>
        <input
          type="text"
          placeholder="Filter queries..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:text-gray-100"
        />
      </div>
      <div className="flex-1 overflow-y-auto p-2 space-y-2">
        {loading ? (
          <div className="text-center py-8 text-gray-500 dark:text-slate-400 text-sm">Loading...</div>
        ) : filteredQueries.length === 0 ? (
          <div className="text-center py-8 text-gray-500 dark:text-slate-400 text-sm">
            {searchTerm ? 'No queries match your search' : 'No saved queries yet'}
          </div>
        ) : (
          filteredQueries.map((q) => {
            const id = q.id || q.Id;
            const isSelected = selectedQuery && (selectedQuery.id === id || selectedQuery.Id === id);
            const tenant = q.tenantName || q.TenantName;
            return (
              <div
                key={id}
                className="group p-3 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-950 border border-transparent hover:border-blue-100 cursor-pointer transition-all"
                onClick={() => onSelect(q)}
              >
                <div className="flex justify-between items-start">
                  <h4 className="font-medium text-gray-700 dark:text-gray-300 text-sm mb-1 group-hover:text-blue-700">
                    {q.title || q.Title}
                  </h4>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm('Delete this query?')) onDelete(id);
                    }}
                    className="text-gray-300 dark:text-slate-600 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity p-0.5"
                    title="Delete"
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-semibold bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-gray-400 uppercase tracking-wide">
                  {tenant}
                </span>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default SavedQueriesList;
